import events from "dom-helpers/events";

import animateCSS from "./animations";
import { renderValidationErrors, showRequestError } from "./utils";

import newParticipantTemplate from "../templates/participants/new.handlebars";
import participantStatusImage from "../../images/status_registered.png";
import remailFlashMessageTemplate from "../templates/participants/remail.handlebars";

export function newParticipantHandler() {
  const elem = document.getElementById("new_participant");
  if (elem !== null && typeof elem !== "undefined") {
    events.on(elem, "ajax:success", (event) => {
      const data = event.detail && event.detail[0];
      const list = document.getElementById("wichtel_list");
      if (!data || !data.participant || typeof data.participant !== "object" || !list) {
        showRequestError("server");
        return;
      }
      data.participant.status_image = participantStatusImage;

      document.getElementById("wichtel_list").insertAdjacentHTML("beforeend", newParticipantTemplate(data.participant));
      animateCSS("#wichtel_list > li.hidden:last-child", "fadeIn");
      document.querySelectorAll("#new_participant span.error").forEach((elem) => {
        elem.parentNode.removeChild(elem);
      });
      event.target.reset();
    });
  }
}

export function newParticipantErrorHandler() {
  const elem = document.getElementById("new_participant");
  if (elem !== null && typeof elem !== "undefined") {
    events.on(elem, "ajax:error", (event) => {
      event.validationErrorsRendered = renderValidationErrors(event, elem, "participant");
    });
  }
}

export function removeParticipantHandler() {
  const elem = document.querySelector("#wichtel_list");
  if (elem !== null && typeof elem !== "undefined") {
    events.on(
      elem,
      "ajax:complete",
      events.filter("a.delete", (event) => {
        const xhr = event.detail && event.detail[0];
        const participant = event.target.closest("li");
        if (xhr && xhr.status >= 200 && xhr.status < 300 && participant) {
          animateCSS(participant, "fadeOut", (node) => node.remove());
        }
      })
    );
  }
}

export function editParticipantDetailsHandler() {
  document.querySelectorAll("#button-yes, #button-no").forEach((button) => {
    button.addEventListener("mouseenter", (event) => {
      const node = event.currentTarget;
      const state = node.id === "button-yes" ? "happy" : "sad";
      const imageEl = document.getElementById("wichtelillu-img");

      imageEl.dataset.className = imageEl.className;
      imageEl.className = state;
    });
    button.addEventListener("mouseleave", () => {
      const imageEl = document.getElementById("wichtelillu-img");

      imageEl.className = imageEl.dataset.className;
      imageEl.dataset.className = "";
    });
    button.addEventListener("click", (event) => {
      event.preventDefault();

      const targetEl = event.currentTarget;
      const state = targetEl.id === "button-yes" ? "confirmed" : "canceled";
      const imageEl = document.getElementById("wichtelillu-img");

      imageEl.dataset.className = imageEl.className;

      document.querySelectorAll("#button-yes, #button-no").forEach((elem) => {
        elem.className = "passive";
      });

      targetEl.classList.toggle("active");
      targetEl.classList.toggle("passive");

      document.getElementById("participant_status").value = state;
      return false;
    });
  });
}

export function remailParticipantHandler() {
  const elem = document.querySelector("ul.grouplist");
  if (elem !== null && typeof elem !== "undefined") {
    events.on(
      elem,
      "ajax:success",
      events.filter("a.remail", (event) => {
        let flashMessageContainer = document.getElementById("flashMessages");
        if (flashMessageContainer !== null && typeof flashMessageContainer !== "undefined") {
          flashMessageContainer.innerHTML = remailFlashMessageTemplate(event.detail[0]);
          flashMessageContainer.style.display = "block";
          animateCSS(flashMessageContainer, "fadeOut", (node, _animationName) => {
            node.style.display = "none";
          });
        }
      })
    );
  }
}
